import React, { useState, useEffect } from 'react';
import Login from './Login';
import SignUp from './SignUp';
import OtpSignup from './OtpSignup';
import ForgotPassword from './ForgotPassword';
import './otpsignup.scss';
import logoIconSrc from '../../../assets/images/logo.svg';
import loginImageSrc from '../../../assets/images/Login_Welcome.png';
import signupImageSrc from '../../../assets/images/Sign-up_Welcome.png';

const AuthForm = () => {
  const queryParams = new URLSearchParams(window.location.search);
  const mode = queryParams.get('mode'); // 'login' or 'signup'

  const [isSignUpPanelActive, setIsSignUpPanelActive] = useState(false);
  const [showOtpScreen, setShowOtpScreen] = useState(false);
  const [signUpData, setSignUpData] = useState(null);
  const [isForgotPanelActive, setIsForgotPanelActive] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [isMobileView, setIsMobileView] = useState(false);

  // Detect screen size
  useEffect(() => {
    const handleResize = () => {
      setIsMobileView(window.innerWidth <= 768); // Mobile view for screens <= 768px
    };

    handleResize();
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  // Show selected panel based on mode
  useEffect(() => {
    setIsSignUpPanelActive(mode === 'signup');
  }, [mode]);

  // Show login panel
  const handleLogin = () => {
    setIsSignUpPanelActive(false);
    setShowOtpScreen(false);
    setIsForgotPanelActive(false);
  };

  // Show signup panel
  const handleSignUp = () => {
    setIsSignUpPanelActive(true);
  };

  // Redirect to login after sign up completion
  const handleSignUpComplete = () => {
    window.location.replace('/users/sign_in');
  };

  // Show forgot password panel
  const handleForgotPassword = () => {
    setIsForgotPanelActive(true);
  };

  // Show password on Login
  const toggleShowPassword = () => {
    setShowPassword(prev => !prev);
  };

  if (isMobileView) {
    // Mobile view layout
    return (
      <div className="h-screen flex items-center py-4 px-10">
        <div className="container mx-auto relative bg-white rounded-lg transition-all duration-600"> 
          
          {/* Login panel */}
          {!isSignUpPanelActive && (
            <div className="w-full flex flex-col items-center">

              <div className="bg-white justify-center flex-col h-full text-left p-12 w-96">
                <div className="text-left w-full max-w-md">
                  <img src={logoIconSrc} alt="Logo" className="w-32 h-12 mx-auto mb-8" />
                </div>
                <h1 className="text-sm font-medium text-gray-700 text-center">Login</h1>
                <h1 className="text-3xl text-purple-500 font-medium text-center">Welcome back</h1>

                {/* Login component */}
                <div className="mt-10">
                  <Login 
                    handleForgotPassword={handleForgotPassword} 
                    showPassword={showPassword}
                    handleSignUp={handleSignUp}
                    toggleShowPassword={toggleShowPassword}
                  />
                </div>
              </div>
            </div>
          )}

          {/* SignUp panel */}
          {isSignUpPanelActive && (
            <div className="w-full flex flex-col items-center">
              <div className="bg-white justify-center flex-col h-full text-left mx-auto p-12 w-96">
                <div className="text-left w-full">
                  <img src={logoIconSrc} alt="Logo" className="w-32 h-12 mx-auto mb-8 mt-8" />
                </div>
                <h1 className="text-sm font-medium text-gray-700">Sign up</h1>
                <h1 className="text-3xl text-purple-500 font-medium">Welcome to Etapath</h1>
            
                {/* Sign up component */}
                <div className="mt-10">
                  <SignUp
                    onComplete={(data) => {
                      setSignUpData(data);
                      setShowOtpScreen(true);
                      setIsSignUpPanelActive(false);
                    }}
                    handleLogin={handleLogin}
                  />
                </div>
              </div>
            </div>
          )}
        </div>

        {/* OtpSignup panel */}
        {showOtpScreen && (
          <div className="absolute top-0 left-0 w-full h-full z-50 px-5 py-2">
            <div className="relative h-full rounded-lg bg-gradient-to-r from-purple-500 to-peach-500 text-white px-10">
            
              {/* OtpSignup component */}
              <div className="flex items-center justify-center flex-col text-center h-full px-10">
                <OtpSignup
                  signUpData={signUpData}
                  onBack={() => setShowOtpScreen(false)}
                  onComplete={handleSignUpComplete}
                />
              </div>
            </div>
        </div>
        )}

        {/* ForgotPassword panel */}
        {isForgotPanelActive && (
          <div className="absolute top-0 left-0 w-full h-full z-50 px-5 py-2">
            <div className="relative h-full rounded-lg bg-gradient-to-r from-purple-500 to-peach-500 text-white px-10">
              <div className="flex items-center justify-center flex-col text-center h-full px-10">
                <ForgotPassword
                  onBack={() => setIsForgotPanelActive(false)} 
                />
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }

  // Desktop view layout
  return (
    <div className="h-screen flex items-center py-4 px-10">
      <div className="w-full h-full relative bg-white rounded-xl flex justify-center"> 
        
        {/* Login panel */}
        <div className="w-1/2 h-full flex flex-col items-center justify-center">
          <div className="text-left w-full ">
            <img src={logoIconSrc} alt="Logo" className="w-32 h-12 ml-0" />
          </div>
          <div className="bg-white justify-center flex-col h-full text-left p-12 w-96">
            <h1 className="text-sm font-medium text-gray-700">Login</h1>
            <h1 className="text-3xl text-purple-500 font-medium">Welcome back</h1>

            {/* Login component */}
            <div className="mt-10">
              <Login 
                handleForgotPassword={handleForgotPassword} 
                showPassword={showPassword}
                handleSignUp={handleSignUp}
                toggleShowPassword={toggleShowPassword}
              />
            </div>
          </div>
        </div>

        {/* Sign up panel */}
        <div className="w-1/2 h-full flex flex-col items-center justify-center">
          <div className="text-left w-full">
            <img src={logoIconSrc} alt="Logo" className="w-32 h-12 ml-8" />
          </div>
          <div className="bg-white flex flex-col text-left p-6 h-full max-w-full">
            <h1 className="text-sm font-medium text-gray-700">Sign up</h1>
            <h1 className="text-3xl text-purple-500 font-medium">Welcome to Etapath</h1>
          
            {/* SignUp component */}
            <div className="mt-5">
              <SignUp onComplete={(data) => {
                setSignUpData(data);
                setShowOtpScreen(true);
                setIsSignUpPanelActive(false);
              }}
                handleLogin={handleLogin}
              />
            </div>
          </div>
        </div>
      </div>

      {/* OTP signup panel */}
      {showOtpScreen && (
        <div className="absolute top-0 left-0 w-full h-full z-50 px-5 py-2">
          <div className="relative h-full rounded-xl bg-gradient-to-r from-purple-500 to-peach-500 text-white px-10">
           
            {/* OtpSignup component */}
            <div className="flex items-center justify-center flex-col text-center h-full px-10">
              <OtpSignup
                signUpData={signUpData}
                onBack={() => setShowOtpScreen(false)}
                onComplete={handleSignUpComplete}
              />
            </div>
          </div>
        </div>
      )}

      {/* Forgot password panel */}
      {isForgotPanelActive && (
        <div className="absolute top-0 left-0 w-full h-full z-50 px-5 py-2">
          <div className="relative h-full rounded-xl bg-gradient-to-r from-purple-500 to-peach-500 text-white px-10">
            
            {/* ForgotPassword component */}
            <div
              className="flex items-center justify-center flex-col text-center h-full">
              <ForgotPassword
                onBack={() => setIsForgotPanelActive(false)} 
              />
            </div>
          </div>
        </div>
      )}

      {/* Overlay Container */}
      <div 
        className={`absolute right-0 top-0 h-full w-1/2 transition-transform duration-300 transform p-4 ${
          isSignUpPanelActive ?  '-translate-x-full' : 'translate-x-0'
        } flex items-center justify-center`}
      >
        <div className="h-full w-full flex justify-center items-center rounded-xl bg-purple-500">
          <div className="h-4/5 w-4/5">
            <img 
              src={isSignUpPanelActive ? signupImageSrc : loginImageSrc} 
              alt={isSignUpPanelActive ? 'Sign Up' : 'Login'}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AuthForm;